exports.onRouteUpdate = () => {
  window.scrollTo(0, 0);
};
